import * as React from 'react';

// Utils
import { t } from '@toolkit/util/i18n';
// Constants
// Actions
// Models & Interfaces
import { UserModel } from '@src/shared/src/models';
import { ConciergeLink } from '@src/components/ConciergeLink';
import { SEARCH_BAR_RENTAL_LINK_TYPE } from '@toolkit/const/app';
// Components

type Props = {
  profile: UserModel;
};

export const RequestHotelLink: React.FC<Props> = ({ profile: { email } }) => {
  return (
    <div className="lp-hotels-conn-request" id="hotels-list-request-form">
      <strong>{t('hotelsConn.link.typeform.title')}</strong>
      {t('hotelsConn.link.typeform.label')}
      <ConciergeLink className="button" formType={SEARCH_BAR_RENTAL_LINK_TYPE.SPECIALHOTELS}>
        {t('hotelsConn.link.typeform.button')}
      </ConciergeLink>
    </div>
  );
};
